<template>
    <div class="list-group">
        <div v-for="(item, index) in propsRows" :key="index" @click="goToWorkTip(item)">
            <a class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 text-primary">{{item.Subject.slice(0,40) + (item.Subject.length > 40 ? '...' : '')}}</h5>
                <small>{{item.DateTimeInsert}}</small>
              </div>
              <p class="mb-1" style="font-size:12px">{{item.ProblemDescription.slice(0, 80) + (item.ProblemDescription.length > 80 ? '...' : '')}}</p>
              <small class="">{{item.NamFam}}</small>
            </a>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      commentPage: false,
      subject: "",
      render: true,
      propsRows: [],
      propsRowsComment: [],
      url: this.URL,
      temp: [],
      addRow: false,
      requestAdd: {
        Subject: null,
        ProblemDescription: null,
        SolutionDescription: null,
        Attachment: null,
        NamFam: null,
        TipTypeName: null,
      },
      tblComment: [],
      tblWorkTip: [],
      selectIdTblWorkTip: null,
      isCreatorWorkTip: false,
      showFullText: false,
      FullText: "",
    };
  },
  mounted() {
    this.GetWorkTips();
    this.$store.state.Modal = false;
  },
  methods: {
    goToWorkTip(item){
      this.$router.push({name: 'WorkTips', params: { pushFromDashbordId: item.Id } })
    },
    showSolutionDescription(text) {
      this.showFullText = true;
      this.FullText = text;
    },
    addComment() {
      this.addCommentShow = true;
    },
    GetResultGrp51(data) {
      if (data.id != null) {
        this.requestAdd.TipTypeGrp51 = data.id;
      }
    },

    GetWorkTips() {
      let DataaxiosDepUser = {
        Action: "WorkTips/GetWorkTipsDashbord",
        Method: "Post",
        ArryfildValue: {
          TblUserIdSeen: this.$session.get("UserInfo").tblUserId
        },
      };

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.propsRows = res;
        })
        .catch((error) => {
          this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
          console.error("CATCH", error);
        })
        .finally(() => {
          this.render = false;
          this.$nextTick(() => {
            this.render = true;
          });
        });
    },

    AddRow() {
      this.addRow = true;
    },

    back() {
      this.propsRows = this.temp;
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
  },
};
</script>

